(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dg-premium-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dg-premium-navigation')) {
    customElements.define('dg-premium-navigation', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized) return;
        this.dataset.initialized = 'true';
        const drawer = this.closest('header-drawer');
        const details = drawer?.querySelector('.dg-menu__details');
        const trigger = details?.querySelector('summary');
        let storyTarget = null;
        details?.addEventListener('toggle', () => {
          if (details.open) return;
          if (storyTarget) {
            const target = storyTarget;
            storyTarget = null;
            window.location.hash = target.id;
            target.scrollIntoView({block: 'start', behavior: 'auto'});
            target.focus({preventScroll: true});
          } else {
            trigger?.focus({preventScroll: true});
          }
        });
        this.addEventListener('click', event => {
          if (!(event.target instanceof Element)) return;
          const link = event.target.closest('a');
          if (!link || event.defaultPrevented || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          if (link.hasAttribute('data-dg-story-link')) {
            const target = document.getElementById('dastageer-owner-story');
            if (target) {
              event.preventDefault();
              storyTarget = target;
            }
          }
          drawer?.close();
        });
        this.querySelector('form')?.addEventListener('submit', () => drawer?.close());
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dg-premium-product"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dg-premium-product')) {
    customElements.define('dg-premium-product', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized) return;
        this.dataset.initialized = 'true';
        const quantity = this.querySelector('[data-quantity]');
        const decrease = this.querySelector('[data-quantity-change="-1"]');
        const increase = this.querySelector('[data-quantity-change="1"]');
        const syncQuantity = () => {
          if (!quantity) return;
          if (decrease) decrease.disabled = quantity.disabled || Number(quantity.value) <= Number(quantity.min || 1);
          if (increase) increase.disabled = quantity.disabled || (quantity.max !== '' && Number(quantity.value) + Number(quantity.step || 1) > Number(quantity.max));
        };
        syncQuantity();
        quantity?.addEventListener('input', syncQuantity);
        quantity?.addEventListener('change', syncQuantity);
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-image-button], [data-quantity-change]');
          if (!button || !this.contains(button)) return;
          if (button.hasAttribute('data-quantity-change') && quantity && !quantity.disabled) {
            Number(button.dataset.quantityChange) > 0 ? quantity.stepUp() : quantity.stepDown();
            quantity.dispatchEvent(new Event('change', {bubbles: true}));
            return;
          }
          if (!button.hasAttribute('data-image-button')) return;
          const image = this.querySelector('[data-main-image]');
          const zoom = this.querySelector('[data-main-zoom]');
          if (!image) return;
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.src = button.dataset.imageSrc;
          image.alt = button.dataset.imageAlt;
          if (zoom) zoom.href = button.dataset.imageZoom;
          this.querySelectorAll('[data-image-button]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dg-xtrike-product"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dg-xtrike-product')) {
    customElements.define('dg-xtrike-product', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized) return;
        this.dataset.initialized = 'true';
        const quantity = this.querySelector('[data-quantity]');
        const decrease = this.querySelector('[data-quantity-change="-1"]');
        const syncQuantity = () => {
          if (decrease && quantity) decrease.disabled = Number(quantity.value) <= Number(quantity.min || 1);
        };
        syncQuantity();
        quantity?.addEventListener('change', syncQuantity);
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-image-button], [data-quantity-change]');
          if (!button || !this.contains(button)) return;
          if (button.hasAttribute('data-quantity-change') && quantity) {
            Number(button.dataset.quantityChange) > 0 ? quantity.stepUp() : quantity.stepDown();
            quantity.dispatchEvent(new Event('change', { bubbles: true }));
            return;
          }
          const image = this.querySelector('[data-main-image]');
          const zoom = this.querySelector('[data-main-zoom]');
          if (!image) return;
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.src = button.dataset.imageSrc;
          image.alt = button.dataset.imageAlt;
          if (zoom) zoom.href = button.dataset.imageZoom;
          this.querySelectorAll('[data-image-button]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        });
        this.querySelector('[data-variant-select]')?.addEventListener('change', (event) => {
          const selected = event.target.selectedOptions[0];
          this.querySelectorAll('[data-price]').forEach((price) => { price.textContent = selected.dataset.price; });
          this.querySelectorAll('[data-cart-button]').forEach((button) => { button.disabled = selected.dataset.available !== 'true'; });
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
